export default "__VITE_ASSET__aWPdxIfO__"